import { render, staticRenderFns } from "./init-excel.vue?vue&type=template&id=0b1207a5&scoped=true"
import script from "./init-excel.vue?vue&type=script&lang=js"
export * from "./init-excel.vue?vue&type=script&lang=js"
import style0 from "./init-excel.vue?vue&type=style&index=0&id=0b1207a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1207a5",
  null
  
)

export default component.exports